<template>
  <div class="variant-modal">
    <Card
      v-if="!loading"
      :bordered="true">
      <div
        slot="title"
        style="padding: 0.8em 0">
        <h4>{{ title }}</h4>
        <a
          v-if="(!reseller && step === 1) || (reseller && step === 0)"
          :href="reseller?'/panel':'/'"
          style="position: absolute;left: 1.33em;top:2em">
          بازگشت به چاپچی
          <Icon type="ios-arrow-back" />
        </a>
        <span
          v-if="(!reseller && step > 1) || (reseller && step > 0)"
          style="position: absolute;left: 2em;top:2em;cursor: pointer"
          @click="step--">
          بازگشت
          <Icon type="ios-arrow-back" />
        </span>
      </div>
      <div
        v-if="step === 0"
        style="overflow-y:auto;max-height: 30em">
        <Row type="flex">
          <Input
            v-model="art_search"
            placeholder="جستجو..."></Input>
        </Row>
        <Row
          :gutter="12"
          type="flex"
          class="code-row-bg"
          justify="center">
          <Col
            :xs="2"
            :sm="4"
            :md="6"
            :lg="8"
            class="select-cat"
            style="width: 150px;height: 150px;text-align: center;font-size: 6em"
          >
          <div
            style="width: 100%;height: 100%"
            @click="setFile('')">
            +
          </div>
        </Col>
          <Col
            v-for="art in artworksSearch"
            :xs="2"
            :sm="4"
            :md="6"
            :lg="8"
            :key="art.id + `_cat`"
            class="select-cat"
            style="width: 150px;height: 150px;text-align: center;overflow: hidden"
          >
          <div
            class="chess-bg"
            @click="setFile(art.filename)"
          >
            <img
              :src="`/reseller_privates/extra_artworks/thumb_` + art.filename"
              style="width: 100%">
          </div>
        </Col>
        </Row>
      </div>
      <Row
        v-if="step === 1"
        :gutter="12"
        class="code-row-bg"
        justify="center">
        <div
          v-for="category in categories"
          :key="category.id + `_cat`"
          class="select-cat"
          @click="BlankStep(category.id)"
        >
          {{ category.name }}
        </div>
      </Row>
      <Row
        v-else-if="step === 2"
        :gutter="12"
        class="code-row-bg"
        justify="center">
        <div
          v-for="blank in currentBlanks"
          :key="blank.blanks_id + `_blank`"
          class="select-cat"
          @click="VariantStep(blank.blanks_id)"
        >
          {{ blank.name }}
        </div>
      </Row>
      <div v-else-if="step === 3">
        <div
          v-if="active_blank.types.length > 1">
          <h3>نوع محصول</h3>
          <br>
          <Row
            :gutter="12"
            class="code-row-bg"
            justify="center">
            <div
              v-for="blankType in active_blank.types"
              :key="blankType.type_id + `_types`"
              :class="`select-cat ` + (variant.type_id === blankType.type_id?'is-active':'')"
              @click="variant.type_id = blankType.type_id"
            >
              {{ blankType.gender_name }}
            </div>
          </Row>
        </div>
        <div
          v-if="active_blank.sizes.length > 1">
          <h3>سایز محصول</h3>
          <br>
          <Row
            :gutter="12"
            class="code-row-bg"
            justify="center">
            <div
              v-for="size in active_blank.sizes"
              :key="size.size_id + `_sizes`"
              :class="`select-cat` +(isActiveSize(size.size_id)?'':' disabled')+ (variant.size_id === size.size_id?' is-active':'')"
              @click="setSize(size.size_id)"
            >
              {{ size.size_name }}
            </div>
          </Row>
        </div>
        <div
          v-if="active_blank.colors.length > 1"
        >
          <divider />
          <h3>رنگ محصول</h3>
          <br>
          <Row
            :gutter="12"
            class="code-row-bg"
            justify="center">
            <div
              v-for="color in active_blank.colors"
              :key="color.color_id + `_color`"
              :style="`border-bottom:0.5em solid `+(color.color_hex==='#ffffff'?'#f8f8ff':color.color_hex)"
              :class="`select-color select-cat` + (isActiveColor(color.color_id)?'':' disabled')+ ((variant.color_id === color.color_id)?' is-active':'')"
              @click="setColor(color.color_id)"
            >
              {{ color.color_name }}
            </div>
          </Row>
        </div>
        <br>
        <Row>
          <Button
            size="large"
            block
            style="width: 100%"
            type="success"
            icon="md-checkmark-circle-outline"
            @click="Finalize"/>
        </Row>
      </div>
      <div slot="extra">
        <Button
          type="error"
          icon="ios-close"
          @click="$emit('close')"/>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'VariantSelector',
  props: {
    stock: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      step: 1,
      art_search: '',
      designer_category: 0,
      designer_blank: 0,
      categories: [],
      blanks: [],
      active_blank: {},
      extraArt: '',
      reseller: false,
      artworks: [],
      variant: {
        blank_id: 0,
        size_id: 0,
        type_id: 0,
        color_id: 0
      }
    }
  },
  computed: {
    artworksSearch () {
      if (this.art_search === '') {
        return this.artworks
      }
      return this.artworks.filter(art => art.name.indexOf(this.art_search) > -1)
    },
    currentBlanks () {
      return this.blanks.filter(blank => blank.designer_category === this.designer_category)
    },
    title () {
      switch (this.step) {
        case 0:
          return 'انتخاب طرح'
        case 1:
          return 'انتخاب گروه'
        case 2:
          return 'انتخاب محصول'
      }
      return this.active_blank.name
    }
  },
  mounted () {
    this.extraArt = window.location.search.replace('?reseller=', '')
    this.reseller = window.location.search.indexOf('?reseller') > -1

    this.axios.get('/designer/categories').then(response => {
      this.categories = response.data.data
    }).catch(() => {
      this.showError('خطا در ارتباط')
    })

    this.axios.get('/designer/blanks' + (this.reseller ? '?reseller=1' : '')).then(response => {
      this.blanks = response.data
    }).catch(() => {
      this.showError('خطا در ارتباط')
    })

    if (this.reseller) {
      this.axios.get('/reseller/extra_artwork/', {
        headers: {
          Authorization: 'Bearer ' + window.localStorage.getItem('default_auth_token')
        }
      })
        .then(response => {
          this.artworks = response.data.data
          if (this.artworks.length > 0) {
            this.step = 0
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  methods: {
    isActiveColor (colorID) {
      let stock = this.stock.find(s => {
        return s.blank_id === this.variant.blank_id &&
        s.blank_size === this.variant.size_id &&
        s.blank_type === this.variant.type_id &&
        s.blank_color === colorID
      })
      if (typeof stock === 'undefined') {
        return false
      }
      return stock.quantity !== 0
    },
    isActiveSize (sizeID) {
      let stocks = this.stock.filter(s => {
        return s.blank_id === this.variant.blank_id &&
        s.blank_size === sizeID &&
        s.blank_type === this.variant.type_id
      })
      if (typeof stocks === 'undefined' || stocks.length === 0) {
        return false
      }
      let isActive = false
      stocks.forEach(st => {
        if (st.quantity !== 0) {
          isActive = true
        }
      })
      return isActive
    },
    BlankStep (id) {
      this.designer_category = id
      this.step = 2
    },
    VariantStep (id) {
      this.variant.blank_id = id
      this.step = 3
      this.active_blank = this.blanks.find(blank => blank.blanks_id === this.variant.blank_id)
      if (typeof this.active_blank === 'undefined') {
        this.showError('خطایی رخ داده است')
        this.step = 1
      } else {
        this.variant.type_id = this.active_blank.types[0].type_id
        this.variant.size_id = this.active_blank.sizes[0].size_id
        this.variant.color_id = this.active_blank.colors[0].color_id
      }
      if (this.active_blank.types.length === 1 &&
          this.active_blank.sizes.length === 1 &&
          this.active_blank.colors.length === 1) {
        this.Finalize()
      }
    },
    setFile (filename) {
      this.extraArt = filename
      this.step = 1
    },
    setColor (id) {
      if (!this.isActiveColor(id)) {
        this.showError('این محصول موجود نمی‌باشد')
        return
      }
      this.variant.color_id = id
    },
    setSize (id) {
      if (!this.isActiveSize(id)) {
        this.showError('این محصول موجود نمی‌باشد')
        return
      }
      this.variant.size_id = id
    },
    Finalize () {
      this.loading = true
      this.axios.post('/designer/plate' + (this.extraArt.length > 29 ? '?extra_art=' + this.extraArt : ''), this.variant).then(response => {
        // this.$emit('add', response.data)
        this.$emit('add')
      }).catch((error) => {
        if (typeof error.response.data.message !== 'undefined') {
          this.showError(error.response.data.message)
        } else {
          this.showError('خطا در ارتباط')
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .variant-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    width: 100%;
    height: 100%;
    padding: 3.33%;
    background: rgba(0, 0, 0, .3);
  }

  .select-cat {
    cursor: pointer;
    border: 1px dashed #d2d2d2;
    padding: 1.5%;
    margin: 0.66%;
    float: right;
    user-select: none;
  }

  .select-cat:hover {
    border: 1px solid #3cb1ac;
  }

  .select-cat.is-active {
    background: #1ebe6a;
    color: white;
  }
  .select-color{
    transition: all 440ms ease;
    text-shadow: 0 0 2px #fff;
  }
  .select-color.is-active{
    border: 1px dashed #b0b1b1;
  }
  .select-cat.disabled{
    cursor: no-drop;
    background: #d1d1d1;
    opacity: 0.5;
  }
  .chess-bg{
    background-image:
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px),
      linear-gradient(90deg, white 10px, #9e9e9e 10px),
      linear-gradient(90deg, #9e9e9e 10px, white 10px);
    background-position: 0 0, 0 10px, 0 20px, 0 30px, 0 40px, 0 50px,
    0 60px, 0 70px, 0 80px, 0 90px, 0 100px,
    0 110px, 0 120px, 0 130px, 0 140px, 0150px;
    background-repeat: repeat-x;
    background-size: 20px 10px, 20px 10px,
    20px 10px, 20px 10px, 20px 10px, 20px 10px, 20px 10px,
    20px 10px, 20px 10px, 20px 10px, 20px 10px,
    20px 10px, 20px 10px, 20px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/VariantSelector.vue